import { createRouter, createWebHistory } from 'vue-router'
import { pages, layouts } from 'frontendcommon-3'
import { config, routes as dashboardRoutes } from '@/dashboards'

const routes = [
  {
    path: '/',
    component: layouts.LayoutTransition,
    name: 'root',
    redirect: { name: 'login' },
    children: dashboardRoutes
  },
  {
    path: '/404',
    name: '404',
    props: { homeUrl: config.ROOT_SITE },
    component: pages.PageNotFound
  },
  {
    path: '/:pathMatch(.*)*',
    props: { homeUrl: config.ROOT_SITE },
    component: pages.PageNotFound
  }
]

export default () => {
  const router = createRouter({
    history: createWebHistory(),
    routes
  })
  return router
}
